<div class="modal-header modalHeaderDefault">
    <h6 class="modal-title">{{ "RegistrationPage.alreadyRegisterPatient" | translate }}<span *ngIf="data.isFromUnotherUnit"> {{ "RegistrationPage.inAnotherUnit" | translate }}</span></h6> 
    <!-- <mat-icon  mat-mini-fab style="margin-left: auto;" matTooltip="Close" (click)="onNoClick('No')">close</mat-icon> -->
</div>
<div style="height: 100px; overflow: scroll;" >
    <table mat-table [dataSource]="dataSourcePatient" class="mat-elevation-z8" style="width: 100%;">

        <!-- Full Name Column -->
        <ng-container matColumnDef="fullName">
            <th mat-header-cell *matHeaderCellDef>  {{ "RegistrationPage.name" | translate }} </th>
            <td mat-cell *matCellDef="let patient"> {{patient.fullName}} </td>
        </ng-container>

        <!-- DOB Column -->
        <ng-container matColumnDef="dob">
            <th mat-header-cell *matHeaderCellDef> {{ "RegistrationPage.dobColumn" | translate }} </th>
            <td mat-cell *matCellDef="let patient"> {{patient.dob}} </td>
        </ng-container>

        <!-- Gender Column -->
        <ng-container matColumnDef="gender">
            <th mat-header-cell *matHeaderCellDef> {{ "RegistrationPage.gender" | translate }} </th>
            <td mat-cell *matCellDef="let patient"> {{patient.gender}} </td>
        </ng-container>

        <!-- Mobile Number Column -->
        <ng-container matColumnDef="mobileNumber">
            <th mat-header-cell *matHeaderCellDef> {{ "RegistrationPage.phone" | translate }} </th>
            <td mat-cell *matCellDef="let patient"> {{patient.mobileNumber}} </td>
        </ng-container>

        <!-- Email Id Column -->
        <ng-container matColumnDef="emailId">
            <th mat-header-cell *matHeaderCellDef> {{ "RegistrationPage.emailId" | translate }} </th>
            <td mat-cell *matCellDef="let patient"> {{patient.emailId}} </td>
        </ng-container>

        <!-- Identification Id Column -->
        <ng-container matColumnDef="identificationId">
            <th mat-header-cell *matHeaderCellDef> {{ "RegistrationPage.identificationId" | translate }} </th>
            <td mat-cell *matCellDef="let patient"> {{patient.identificationId}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onRowClick(row.id)"
            [class.selected-row]="selectedId === row.id">
        </tr>

    </table>

</div>
<div class="modal-footer" style="align-self: center;">
    <button  *ngIf="isNewPatientBtnShow" class="btnCyan" style="border: none; border-radius: 5px;" (click)="onNoClick('No')" matTooltip="Confirm">
        <div style="display: flex;"> <mat-icon  mat-mini-fab>person</mat-icon> <span style="align-content:center">{{ "RegistrationPage.continueWithNewPatient" | translate }}</span></div>
    </button>
&nbsp;&nbsp;&nbsp;&nbsp;
    <button class="btnCyan" style="border: none; border-radius: 5px;" (click)="confirmPatient()" matTooltip="Confirm">
        <div style="display: flex;"> <mat-icon  mat-mini-fab>person_add</mat-icon> <span style="align-content:center">{{ "RegistrationPage.continueWithExistingPatient" | translate }}</span></div>
    </button>
</div>